module.exports = __webpack_public_path__ + "static/media/icon-search.a7160bb2.svg";